import { render, staticRenderFns } from "./BoostSalesHistory.vue?vue&type=template&id=51c7bb38"
import script from "./BoostSalesHistory.vue?vue&type=script&lang=js"
export * from "./BoostSalesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports